const resetPasswordField = ['NewPassword', 'ConfirmPassword'];
export { resetPasswordField };
